<template>
  <div>
    <p
      v-if="rowValue != 0"
      :class="ClassObject"
      style="cursor: pointer"
      @click="onClicked(column, row)"
      plain
    >
      {{ rowValue }}
      <!--<span v-if="Months.includes(column.property)"></span>-->
    </p>
  </div>
</template>

<script>
export default {
  name: "LinkDialogOpenerForReportByProduct",
  props: {
    rowValue: {
      type: Number,
      default: 0,
      required: true
    },
    row: {
      type: Object,
      default: () => ({}),
      required: true
    },
    column: {
      type: Object,
      default: () => ({}),
      required: true
    },
    call: {
      type: Function,
      default: () => {},
      required: true
    }
  },
  data() {
    return {
      Months: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December"
      ]
    };
  },
  computed: {
    ClassObject() {
      const isBlue = true;
      let classObject;
      classObject = {
        Blue: isBlue
      };

      return classObject;
    }
  },
  methods: {
    onClicked(column, row) {
      this.call(column, row);
    }
  }
};
</script>

<style lang="scss" scoped>
.Blue {
  color: blue;
}
</style>
